module.exports = __webpack_public_path__ + "static/media/queuetube-demo.5cff3db5.gif";